import React, {useState, useEffect} from "react";
import {
  Container,
  Divider,
  Grid,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import {Link, useLocation, useNavigate} from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ProductsContainer from "../../components/app/Products/ProductsContainer";
import VerticalLinearStepper from "../../components/common/Stepper/VerticalLinearStepper";
import CustomButton from "../../components/common/Button/CustomButton";
import AlertDialogSlide from "../../components/common/Dialog/AlertDialogSlide";
import Loader from "../../components/loader/Loader";
import UserDataAPI from "../../api/firebase/UserDataAPI";
import OrdersAPI from "../../api/firebase/OrdersAPI";
import UserProfileContext from "../../context/userProfile/UserProfileContext";
import {useContext} from "react";
import {useRef} from "react";

const OrderDetailPage = () => {
  const navigate = useNavigate();
  const userDataApi = new UserDataAPI();
  const ordersAPI = new OrdersAPI();
  const userProfileContext = useContext(UserProfileContext);
  const [openDialog, setOpenDialog] = useState(false);
  const [cancelOrder, setCancelOrder] = useState(false);
  const [orderSteps, setOrderSteps] = useState([]);
  const activeStepRef = useRef(0);
  const [user, setUser] = useState(null);
  const location = useLocation();
  const order = location.state.order;
  // console.log("order:", order);
  let steps = [];
  const isToday = (dateString) => {
    const today = new Date();
    if (today.toDateString() === dateString) {
      return true;
    }
    return false;
  };
  useEffect(() => {
    if (order !== undefined) {
      let date = new Date(order.createdAt);
      let createdDate = new Date(date).toDateString();
      let label_createdAt = "";
      if (isToday(createdDate)) {
        label_createdAt = "Order confirmed Today";
      } else {
        let date_ = new Date(order.createdAt);
        let num_ = date_.setDate(date_.getDate() + 1);
        let check_date = new Date(num_).toDateString();
        if (isToday(check_date)) {
          label_createdAt = "Order confirmed Yesterday";
        } else {
          label_createdAt =
            "Order confirmed on " + createdDate.substring(0, 10);
        }
      }
      let ex_ship_date = date.setDate(date.getDate() + 2);
      let expectedSD = new Date(ex_ship_date).toDateString().substring(0, 10);

      let ex_delivery_date = date.setDate(date.getDate() + 6);
      let expectedDD = new Date(ex_delivery_date)
        .toDateString()
        .substring(0, 10);
      switch (order.status) {
        case "placed":
          activeStepRef.current = 0;
          steps = [
            {
              label: "Confirmed",
              isCompleted: true,
              subtitle: label_createdAt,
            },
            {
              label: "Shipped",
              isCompleted: false,
              subtitle: "Expected by " + expectedSD,
            },
            {
              label: "Out for Delivery",
              isCompleted: false,
              subtitle: "Expected by " + expectedDD,
            },
            {
              label: "Delivered",
              isCompleted: false,
              subtitle: "Expected by " + expectedDD,
            },
          ];
          break;
        case "shipped":
          activeStepRef.current = 1;
          steps = [
            {
              label: "Confirmed",
              isCompleted: true,
              subtitle: label_createdAt,
            },
            {
              label: "Shipped",
              isCompleted: true,
              subtitle:
                "On " +
                order.shippedAt.substring(0, 10) +
                " at " +
                order.shippedAt.substring(15, 24),
            },
            {
              label: "Out for Delivery",
              isCompleted: false,
              subtitle: "Expected by " + expectedDD,
            },
            {
              label: "Delivered",
              isCompleted: false,
              subtitle: "Expected by " + expectedDD,
            },
          ];
          break;
        case "outfordelivery":
          activeStepRef.current = 2;
          steps = [
            {
              label: "Confirmed",
              isCompleted: true,
              subtitle: label_createdAt,
            },
            {
              label: "Shipped",
              isCompleted: true,
              subtitle:
                order.shippedAt.substring(0, 10) +
                order.shippedAt.substring(15, 24),
            },
            {
              label: "Out for Delivery",
              isCompleted: true,
              subtitle:
                order.ofdAt.substring(0, 10) + order.ofdAt.substring(15, 24),
            },
            {
              label: "Delivered",
              isCompleted: false,
              subtitle: "Expected by today",
            },
          ];
          break;
        case "delivered":
          activeStepRef.current = 4;
          steps = [
            {
              label: "Confirmed",
              isCompleted: true,
              subtitle: label_createdAt,
            },
            {
              label: "Shipped",
              isCompleted: true,
              subtitle:
                order.shippedAt.substring(0, 10) +
                order.shippedAt.substring(15, 24),
            },
            {
              label: "Out for Delivery",
              isCompleted: true,
              subtitle:
                order.ofdAt.substring(0, 10) + order.ofdAt.substring(15, 24),
            },
            {
              label: "Delivered",
              isCompleted: true,
              subtitle:
                order.deliveredAt.substring(0, 10) +
                order.deliveredAt.substring(15, 24),
            },
          ];
          break;
        case "cancelled":
          activeStepRef.current = 2;
          steps = [
            {
              label: "Confirmed",
              isCompleted: true,
              subtitle: label_createdAt,
            },
            {
              label: "Cancelled",
              isCompleted: true,
              subtitle:
                order.cancelledAt.substring(0, 10) +
                order.cancelledAt.substring(15, 24),
            },
          ];
          break;
      }
      console.log("steps:", steps);
      setOrderSteps(steps);
    }
  }, []);

  useEffect(() => {
    if (userProfileContext.state !== null) {
      console.log("user:", userProfileContext.state);
      setUser({...userProfileContext.state});
    } else {
      setUser(null);
    }
  }, [userProfileContext.state]);
  useEffect(() => {
    if (cancelOrder) {
      handleCancelOrder();
    }
  }, [cancelOrder]);
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleAgreeDialog = () => {
    setCancelOrder(true);
    setOpenDialog(false);
  };
  const handleCancelOrder = () => {
    console.log("Cancel order:", order.id);
    // Cancellation Start
    const dataForOrderTable = {
      payload: {
        status: "cancelled",
        cancelledAt: Date().toString(),
      },
      id: order.id,
    };
    ordersAPI.setOrder(dataForOrderTable).then((resOrder) => {
      // console.log("RES ORDER:", resOrder);
      // console.log("user.orders:", user.orders);
      const prevOrders = user.orders !== undefined ? user.orders : [];
      // remove this order
      const prevOrdersSpliced = prevOrders.filter((item, index) => {
        return item.id !== order.id;
      });
      // console.log("prevOrdersSpliced: ", prevOrdersSpliced);
      const dataForUsersTable = {
        id: user.id,
        payload: {
          orders: [
            {
              amount: order.amount,
              createdAt: order.createdAt,
              id: order.id,
              ...dataForOrderTable.payload,
            },
            ...prevOrdersSpliced,
          ],
        },
      };
      // console.log("dataForUsersTable:", dataForUsersTable);
      userDataApi.addUserData(dataForUsersTable).then((res) => {
        // console.log("RES from user data update:", res);
        if (res.success) {
          userProfileContext.setState((prev) => ({
            ...prev,
            orders: [...dataForUsersTable.payload.orders],
          }));
        }
        setTimeout(() => {
          setCancelOrder(false);
          navigate("/userOrders");
        }, 1000);
      });
    });
  };

  return (
    <Container maxWidth="md" sx={{marginTop: "2rem"}}>
      <Grid container spacing={2} sx={{pb: "1rem"}}>
        <Grid item xs={2} sm={1} textAlign="left" sx={{p: "0 !important"}}>
          <IconButton aria-label="back" onClick={() => navigate(-1)}>
            <ArrowBackIcon fontSize="large" />
          </IconButton>
        </Grid>
        <Grid item xs={10} sm={11} sx={{p: "6px 0 !important"}}>
          <Typography variant="body1" color="GrayText">
            Order ID - {order.id}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sx={{p: "6px 0 !important"}}
          display={{xs: "block", sm: "none", md: "none", lg: "none"}}
        >
          <Divider sx={{width: "100vw"}} />
        </Grid>

        <Grid item xs={12} sx={{p: " 0 0 1rem 1rem !important"}}>
          <Paper sx={{p: "1rem"}}>
            <VerticalLinearStepper
              steps={orderSteps}
              activeStep={activeStepRef.current}
              editable={false}
            />
          </Paper>
        </Grid>
        <Grid item xs={12} sx={{p: "6px 1rem !important"}}>
          <Typography variant="body2" component="p" color="GrayText">
            Total Items ({order.items.length})
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{p: "6px !important"}}>
          <Divider />
        </Grid>
        <Grid item xs={12} sx={{pt: "0 !important"}}>
          <ProductsContainer
            heading=""
            showInRow={true}
            addToCartEnable={false}
            showCarousel={false}
            showLikeButton={false}
            productsArray={order.items}
            useMobileSize={true}
            showRating={false}
            showQuantity={true}
          />
        </Grid>
        <Grid item xs={12} sx={{p: "1rem 0 1rem 1rem !important"}}>
          <Paper sx={{p: "1rem"}}>
            <Typography variant="body1" component="p">
              Order amount : &#8377;{order.amount}
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sx={{p: "6px 1rem !important"}}>
          <Typography variant="body2" component="p" color="GrayText">
            Shipping Address
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{p: "6px !important"}}>
          <Divider />
        </Grid>
        <Grid item xs={12} sx={{p: "6px 1rem !important"}}>
          <Typography variant="body1" component="p">
            {order.address.name}
          </Typography>
          <Typography variant="body2" component="p">
            {order.address.address}
          </Typography>
          <Typography variant="body2" component="p">
            {order.address.city}, {order.address.state} -{" "}
            {order.address.pincode}
          </Typography>
          <Typography variant="body2" component="p">
            {order.address.mobile}{" "}
            {order.address.alternateMobile !== ""
              ? `, ${order.address.alternateMobile}`
              : ""}
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{p: "6px !important"}}>
          <Divider />
        </Grid>
        {order.status === "placed" && (
          <Grid item xs={6}>
            <CustomButton
              variant="contained"
              onClick={() => setOpenDialog(true)}
              size="small"
              fullWidth={true}
            >
              Cancel Order
            </CustomButton>
          </Grid>
        )}
        <Grid item xs={order.status === "placed" ? 6 : 12}>
          <Link to="/refund-policy">
            <CustomButton variant="contained" size="small" fullWidth={true}>
              Need Help?
            </CustomButton>
          </Link>
        </Grid>
      </Grid>
      <AlertDialogSlide
        handleOnAgree={handleAgreeDialog}
        handleOnClose={handleCloseDialog}
        isOpen={openDialog}
        title="Cancel Order"
        description="Sure to cancel this order?"
        agreeButtonText="Confirm"
        cancelButtonText="Back"
      />
      {cancelOrder && <Loader />}
    </Container>
  );
};

export default OrderDetailPage;
